import { render, staticRenderFns } from "./OportunidadeDetalhe.vue?vue&type=template&id=4690b8a7&scoped=true"
import script from "./OportunidadeDetalhe.vue?vue&type=script&lang=js"
export * from "./OportunidadeDetalhe.vue?vue&type=script&lang=js"
import style0 from "./OportunidadeDetalhe.vue?vue&type=style&index=0&id=4690b8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4690b8a7",
  null
  
)

export default component.exports